import React from 'react';

function FullScreenMessage({message, children}) {
  return (
    <div style={styles.flex}>
      <div style={styles.container}>
        {children}
        <p style={styles.message}>{message}</p>
      </div>
    </div>
  );
}

const styles = {
  flex: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%'
  },
  container: {
    alignSelf: 'center',
    textAlign: 'center',
    padding: 40
  },
  message: {
    color: '#888'
  }
};

export default FullScreenMessage;
